export enum TrustBoxTheme {
  Dark = 'dark',
  Light = 'light',
}
